module.exports = __webpack_public_path__ + "static/searching-animation-8e7a88c82ef9ec9350caf37ddab78f47.gif";